export default function CardReview({ name, title, img, review, shortCommentStyle, children }) {
    const normalizedReview = review.replace(/\s+/g, " ").trim();
    const preview = normalizedReview.length > 260
        ? `${normalizedReview.slice(0, normalizedReview.lastIndexOf(" ", 260))}…`
        : normalizedReview;

    return (
        <article className="d-flex flex-column w-100 h-100 px-2 pb-4 text-center">
            <div className="d-flex justify-content-center mb-4">
                <img src={img} alt={name} width={140} height={80} className="object-fit-contain mw-100" />
            </div>
            <p className="mb-0 lh-lg">{shortCommentStyle ? preview : review}</p>
            <div className="color-primary-blue mt-auto pt-4 pb-4">
                <p className="mb-0 fw-bold">{name}</p>
                {title && <p className="mt-1 mb-0 small">{title}</p>}
            </div>
            <div className="d-flex flex-column align-items-center">{children}</div>
        </article>
    );
}
